import Errors from './app-wrapper-errors.js'
import Events from './app-wrapper-events.js'
import appWrapperBridgeAPI from './app-wrapper-bridge-api.js'
import appWrapperUtils from './app-wrapper-utils.js'
import { EventTitles } from './app-wrapper-events.js'

let loadingCounter = 0

const promisePublishHandle = appWrapperUtils.promisePublishHandle
const operationStatus = appWrapperUtils.operationStatus

const Loading = {
  show: function () {
    if (loadingCounter < 0) {
      loadingCounter = 0
    }
    loadingCounter++
    return promisePublishHandle(EventTitles.loadingShow, '')
  },
  hide: function (forced) {
    if (forced) {
      loadingCounter = 0
    } else {
      loadingCounter--
    }
    if (loadingCounter <= 0) {
      return promisePublishHandle(EventTitles.loadingHide, '')
    } else {
      // now this is some top level slackery
      // here, have this promise that will never ever be resolved
      return new Promise()
    }
  }
}

const Toolbar = {
  buttons: {
    back: {
      id: 'rm-toolbar-back',
      name: 'Back'
    },
    close: {
      id: 'rm-toolbar-close',
      name: 'Close'
    }
  },
  show: function () {
    return promisePublishHandle(EventTitles.toolbarShow, '')
  },
  hide: function () {
    return promisePublishHandle(EventTitles.toolbarHide, '')
  },
  addItems: function () {},
  removeItems: function () {},
  showBackButton: function () {
    return promisePublishHandle(EventTitles.toolbarBackButtonShow, '')
  },
  hideBackButton: function () {
    return promisePublishHandle(EventTitles.toolbarBackButtonHide, '')
  },
  showCloseButton: function () {},
  hideCloseButton: function () {},
  setTitle: function (titleText) {
    return promisePublishHandle(EventTitles.toolbarTitleUpdate, titleText)
  },
  setTitleBadge: function () {},
  showTitle: function () {
    return promisePublishHandle(EventTitles.toolbarTitleShow, '')
  },
  hideTitle: function () {
    return promisePublishHandle(EventTitles.toolbarTitleHide, '')
  }
}

const Menu = {
  setBadge: function (badgeData) {
    return promisePublishHandle(EventTitles.menuBadgeUpdate, badgeData)
  },
  enableItem: function (menuItemId) {
    return promisePublishHandle(EventTitles.menuItemEnable, menuItemId)
  },
  disableItem: function (menuItemId) {
    return promisePublishHandle(EventTitles.menuItemDisable, menuItemId)
  }
}

const Wrapper = {
  // 0 - wrapper content area, 1 - new window, 2 - replace wrapper
  loadURLLocations: {
    content: 0,
    self: 1,
    new: 2
  },
  loadAppFromAppLauncher: function (data) {
    return promisePublishHandle(EventTitles.loadAppFromAppLauncher, data)
  },
  loadURL: function (config) {
    if (
      typeof config !== 'object' ||
      typeof config.location === 'undefined' ||
      typeof config.src === 'undefined'
    ) {
      return new Promise(function (resolve, reject) {
        let error = {
          name: Errors.ERROR_INVALID_PARAMETERS,
          message:
            'loadURL methods accepts a config object with src and location properties. Please consult the documentation'
        }
        reject(error)
      })
    }

    let location = config.location || this.loadURLLocations.content
    // location values:
    // 0 - wrapper content area, 1 - new window, 2 - replace wrapper
    if (location === this.loadURLLocations.new) {
      let src = config.src
      src = src.trim()
      src = src.toLowerCase()
      // if the src does not start with http:// or https:// it is invalid
      if (src.indexOf('http://') !== 0 && src.indexOf('https://') !== 0) {
        return new Promise(function (resolve, reject) {
          let error = {
            name: Errors.ERROR_INVALID_PARAMETERS,
            message:
              'Src parameter must be a valid URL. The value did not start with http:// or https://.'
          }
          reject(error)
        })
      }

      return appWrapperBridgeAPI.openInBrowser(config)
    } else {
      return promisePublishHandle(EventTitles.contentLoad, config, 5000)
    }
  },
  openSurvey: function (surveyInstanceID) {
    return appWrapperBridgeAPI.openSurvey(surveyInstanceID)
  },
  setActiveItem: function () {},
  getTheme: function () {
    return new Promise(function (resolve, reject) {
      const themeObject = {
        accentColor: '#2C9DEE',
        topBar: {
          backgroundColor: '#4c5057'
        }
      }

      if (typeof themeObject !== 'undefined') {
        resolve(themeObject)
      } else {
        reject()
      }
    })
  }
}

const Modal = {
  show: function (config) {
    return promisePublishHandle(EventTitles.modalShow, config)
  }
}

const AppConfig = {
  get: function (config) {
    return promisePublishHandle(
      EventTitles.getAppConfig,
      config,
      undefined,
      true
    )
  }
}

const Toast = {
  /**
   * @method show
   * @param {*} params - Object with configuration properties for toast visualization
   * @return {Promise}
   */
  show: function (params) {
    const validParams = Object.assign({}, params)

    const defaultProps = [
      {
        name: 'group',
        value: 'default'
      },
      {
        name: 'width',
        value: '100%'
      },
      {
        name: 'position',
        value: 'top center'
      },
      {
        name: 'type',
        value: 'warn'
      },
      {
        name: 'title',
        value: ''
      },
      {
        name: 'text',
        value: 'This is notification demo text!'
      },
      {
        name: 'ignoreDuplicates',
        value: false
      },
      {
        name: 'persist',
        value: false
      },
      {
        name: 'duration',
        value: 3000
      },
      {
        name: 'animationSpeed',
        value: 300
      },
      {
        name: 'classes',
        value: 'vue-notification'
      },
      {
        name: 'maximumToasts',
        value: 1000
      }
    ]

    // Set default properties if doesn't exist
    defaultProps.forEach((item) => {
      if (!Object.prototype.hasOwnProperty.call(validParams, item.name)) {
        validParams[item.name] = item.value
      }
    })

    // Always show toast until clicked
    if (validParams.persist) {
      validParams.duration = -5
    }
    // set animation speed
    validParams.speed = validParams.animationSpeed

    return promisePublishHandle(EventTitles.showToast, validParams)
  }
}
/*
    const Event = {
      toolbarButtonTap: function() {}
    }
    */
export { EventTitles }
export { Toolbar }
export { Loading }
export { Wrapper }
export { Modal }
export { AppConfig }
export { Menu }
export { Errors }
export { Events }
export { Toast }
export { operationStatus as OperationStatus }

export default {
  Loading: Loading,
  EventTitles: EventTitles,
  Toolbar: Toolbar,
  Wrapper: Wrapper,
  Modal: Modal,
  AppConfig: AppConfig,
  Menu: Menu,
  Errors: Errors,
  Events: Events,
  Toast: Toast,
  OperationStatus: operationStatus
}
